import { apiGet, apiPut } from "./http";
import type { MemberLevel } from "../pages/admin/utils/memberLevelStore";

export type MemberLevelBrief = {
  id: string;
  name: string;
  isEnabled?: boolean;
};

type MemberLevelDto = {
  levelKey?: string;
  name?: string;
  description?: string;
  minPoints?: number;
  sortOrder?: number;
  annualFeeYuan?: number;
  benefitIds?: string[];
  badgeClassName?: string;
  isSystem?: boolean;
  ageMinInclusive?: number | null;
  ageMaxInclusive?: number | null;
  isEnabled?: boolean;
};

function dtoToMemberLevel(d: MemberLevelDto, index: number): MemberLevel | null {
  const id = String(d.levelKey ?? "").trim() || String(d.name ?? "").trim();
  const name = String(d.name ?? "").trim();
  if (!id || !name) return null;
  return {
    id,
    name,
    description: String(d.description ?? ""),
    className: String(d.badgeClassName ?? "bg-gray-100 text-gray-600"),
    minPoints: Number(d.minPoints ?? 0) || 0,
    sortOrder: Number.isFinite(d.sortOrder) ? Number(d.sortOrder) : index + 1,
    isSystem: Boolean(d.isSystem),
    benefitIds: Array.isArray(d.benefitIds) ? [...d.benefitIds] : [],
    annualFee: Number(d.annualFeeYuan ?? 0) || 0,
    ageMinInclusive: d.ageMinInclusive ?? null,
    ageMaxInclusive: d.ageMaxInclusive ?? null,
    isEnabled: d.isEnabled !== false,
  };
}

function memberLevelToDto(l: MemberLevel): MemberLevelDto {
  return {
    levelKey: l.id,
    name: l.name,
    description: l.description ?? "",
    minPoints: l.minPoints ?? 0,
    sortOrder: l.sortOrder,
    annualFeeYuan: l.annualFee ?? 0,
    benefitIds: l.benefitIds ?? [],
    badgeClassName: l.className,
    isSystem: l.isSystem,
    ageMinInclusive: l.ageMinInclusive ?? null,
    ageMaxInclusive: l.ageMaxInclusive ?? null,
    isEnabled: l.isEnabled !== false,
  };
}

function mapDtos(rows: MemberLevelDto[] | null | undefined): MemberLevel[] {
  return (Array.isArray(rows) ? rows : [])
    .map((d, i) => dtoToMemberLevel(d, i))
    .filter((x): x is MemberLevel => x != null)
    .sort((a, b) => a.sortOrder - b.sortOrder);
}

export async function fetchMemberLevelsForTenant(tenantLegacyId: string): Promise<MemberLevel[]> {
  const tid = tenantLegacyId.trim();
  if (!tid) return [];
  const rows = await apiGet<MemberLevelDto[]>(`/api/tenants/${encodeURIComponent(tid)}/member-levels`);
  return mapDtos(rows);
}

export async function putMemberLevelsForTenant(
  tenantLegacyId: string,
  levels: MemberLevel[],
): Promise<MemberLevel[]> {
  const tid = tenantLegacyId.trim();
  const body = {
    levels: levels.map(memberLevelToDto),
  };
  const rows = await apiPut<MemberLevelDto[]>(
    `/api/tenants/${encodeURIComponent(tid)}/member-levels`,
    body,
  );
  return mapDtos(rows);
}

/** 活动表单等场景：轻量等级列表（仅 id/name/enabled） */
export async function fetchMemberLevelBriefsForTenant(tenantLegacyId: string): Promise<MemberLevelBrief[]> {
  const levels = await fetchMemberLevelsForTenant(tenantLegacyId);
  return levels.map((l) => ({ id: l.id, name: l.name, isEnabled: l.isEnabled !== false }));
}
